<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <div class="col-md-12">
                <div
                    class="row"
                    style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    "
                >
                    <div class="col-lg-9">
                        <div class="card card-danger card-outline">
                            <div class="card-body overflow-auto"></div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div
                                            class="btn btn-warning"
                                            style="width: 100% !important"
                                            @click="dismissAllNotifications"
                                        >
                                            <i class="fas fa-eraser"> </i>
                                            Dismiss All
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="
                                                deleteAllNotificationsPrompt
                                            "
                                        >
                                            <i class="fas fa-trash"> </i> Delete
                                            All
                                        </div>
                                    </div>
                                </div>
                                <br /><br />
                                <div
                                    v-if="messages != []"
                                    class="row overflow-auto"
                                    v-for="m in messages"
                                >
                                    <div class="dropdown-divider"></div>
                                    <div class="dropdown-item">
                                        <div class="media">
                                            <img
                                                :src="m.sender.profile_pic"
                                                alt="User Avatar"
                                                class="img-size-50 img-circle mr-3"
                                            />
                                            <div class="media-body">
                                                <h3 class="dropdown-item-title">
                                                    <span
                                                        class="badge badge-danger"
                                                        v-if="
                                                            m.user_dismissed !=
                                                            1
                                                        "
                                                        >NEW MESSAGE
                                                    </span>
                                                    {{ m.title }}
                                                    <span
                                                        class="float-right text-sm text-muted"
                                                        ><i
                                                            class="fas fa-eraser"
                                                            @click="
                                                                dismissNotification(
                                                                    m.id
                                                                )
                                                            "
                                                        >
                                                        </i>
                                                        &nbsp; &nbsp;
                                                        <i
                                                            class="fas fa-trash"
                                                            @click="
                                                                deleteNotificationPrompt(
                                                                    m.id
                                                                )
                                                            "
                                                        >
                                                        </i
                                                    ></span>
                                                </h3>
                                                <p class="text-sm">
                                                    {{ m.body }}
                                                </p>
                                                <p class="text-sm text-muted">
                                                    <i
                                                        class="far fa-clock mr-1"
                                                    ></i>
                                                    {{
                                                        m.created_at | timeStamp
                                                    }}
                                                    by
                                                    {{ m.sender.user_detail }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="dropdown-divider"></div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <pagination
                                    :pagination="pagination"
                                    @prev="
                                        getMyNotifications(
                                            pagination.prevPageUrl
                                        )
                                    "
                                    @next="
                                        getMyNotifications(
                                            pagination.nextPageUrl
                                        )
                                    "
                                ></pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- /.content -->

        <!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
        <div class="modal" tabindex="-1" role="dialog" id="deletemessagemodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Delete this message?</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Are you sure?</p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-success"
                            data-dismiss="modal"
                            @click="deleteNotification"
                        >
                            Yes
                        </button>
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="deleteallmodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Delete All Messages?</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Are you sure?</p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-success"
                            data-dismiss="modal"
                            @click="deleteAllNotifications"
                        >
                            Yes
                        </button>
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from "../../pagination.vue";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { pagination: Pagination },

    created() {
        this.getMyNotifications();
        this.pollData();
    },

    data() {
        return {
            errors: [],
            messages: [],
            delete_candidate: "",
            interval: "",
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
        };
    },

    methods: {
        pollData() {
            this.interval = setInterval(() => {
                this.getMyNotifications(
                    "/api/getNotifications" +
                        "?page=" +
                        this.pagination.currentPage
                );
            }, 15000);
        },
        getMyNotifications(url = "/api/getNotifications") {
            axios.post(url).then((response) => {
                this.messages = response.data.data;
                this.configPagination(response.data);
            });
        },
        deleteNotificationPrompt(id) {
            this.delete_candidate = id;
            $("#deletemessagemodal").modal("show");
        },
        deleteAllNotificationsPrompt() {
            $("#deleteallmodal").modal("show");
        },
        deleteNotification() {
            axios
                .post("/api/deleteNotification", { id: this.delete_candidate })
                .then((response) => {
                    toast.fire({
                        icon: "success",
                        title: "Deleted the Message",
                    });
                    this.getMyNotifications();
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },
        dismissNotification(id) {
            axios
                .post("/api/dismissNotification", { id: id })
                .then((response) => {
                    toast.fire({
                        icon: "success",
                        title: "Dismissed the Message",
                    });
                    this.getMyNotifications();
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },
        deleteAllNotifications() {
            axios
                .post("/api/deleteAllNotifications")
                .then((response) => {
                    toast.fire({
                        icon: "success",
                        title: "Deleted All Messages",
                    });
                    this.getMyNotifications();
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },
        dismissAllNotifications() {
            axios
                .post("/api/dismissAllNotifications")
                .then((response) => {
                    toast.fire({
                        icon: "success",
                        title: "Dismissed All Messages",
                    });
                    this.getMyNotifications();
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },
        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
};
</script>
